/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordInput
 */
export interface ChangePasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    newPassword?: string;
}

/**
 * Check if a given object implements the ChangePasswordInput interface.
 */
export function instanceOfChangePasswordInput(value: object): value is ChangePasswordInput {
    return true;
}

export function ChangePasswordInputFromJSON(json: any): ChangePasswordInput {
    return ChangePasswordInputFromJSONTyped(json, false);
}

export function ChangePasswordInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordInput {
    if (json == null) {
        return json;
    }
    return {
        
        'oldPassword': json['oldPassword'] == null ? undefined : json['oldPassword'],
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
    };
}

export function ChangePasswordInputToJSON(json: any): ChangePasswordInput {
    return ChangePasswordInputToJSONTyped(json, false);
}

export function ChangePasswordInputToJSONTyped(value?: ChangePasswordInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oldPassword': value['oldPassword'],
        'newPassword': value['newPassword'],
    };
}

